module.exports = "<p>\n  revisedpropertyregister works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/revisedpropertyregister/revisedpropertyregister.component.html
// module id = ./src/app/planning/revisedpropertyregister/revisedpropertyregister.component.html
// module chunks = main